/** Empty or malformed keys are caught in Providers, which shows a setup message instead. */
const publishableKey = (import.meta.env.VITE_CLERK_PUBLISHABLE_KEY as string | undefined) ?? "";

export const env = { clerkPublishableKey: publishableKey } as const;
